import React from 'react';
import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

interface ErrorToastProps {
  message: string | null;
  onClose: () => void;
  /** ms before auto-dismiss, default 5000 */
  duration?: number;
}

/**
 * Non-blocking error toast.
 * Use when a secondary/non-critical fetch fails and you don't want to block
 * the user from using the rest of the page.
 */
export const ErrorToast = ({ message, onClose, duration = 5000 }: ErrorToastProps) => (
  <Snackbar
    open={!!message}
    autoHideDuration={duration}
    onClose={(_, reason) => reason !== 'clickaway' && onClose()}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
  >
    <Alert severity="error" onClose={onClose} variant="filled">
      {message}
    </Alert>
  </Snackbar>
);
